export function Spinner({ label }: { label?: string }) {
  return (
    <span className="inline-flex items-center">
      {/* The glyph is decorative. The old version put role="status" and an
          aria-label on this span — but a live region announces its TEXT
          CONTENT, and a childless span has none, so inserting it said
          nothing at all: a screen-reader user typed their last digit and
          heard silence for the whole round trip. */}
      <span
        aria-hidden="true"
        className="inline-block size-4 animate-spin rounded-full border-2 border-current border-t-transparent motion-reduce:animate-none"
      />
      {label ? (
        // Announced but not shown: the callers that want visible text render
        // it themselves, next to this.
        <span role="status" className="sr-only">
          {label}
        </span>
      ) : null}
    </span>
  );
}
